import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { AlertasService } from '../core/_services/alerta.service';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-actividad-adicional',
  templateUrl: './actividad-adicional.component.html',
  styleUrls: ['./actividad-adicional.component.scss']
})
export class ActividadAdicionalComponent implements OnInit {

  @Input() fichaActual: any;

  listaActividades: any[];
  listaActividadesFiltradas: any[];
  formularioActividades: FormGroup;
  varObser: boolean = false;
  varDes: boolean = false;
  registrosListaActividades: any;
  totalRecordsActividades: any;
  actividadActualSelec: any;
  columnasActividades: any[];
  formBuilder: FormBuilder;
  formulario: FormGroup;
  verFormulario: boolean = false;

  constructor(
    public coreService: CoreService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    this.formBuilder = new FormBuilder();
  }

  ngOnInit(): void {
    this.formularioActividades = this.formBuilder.group({

      descripcionActividades: [''],
      observacionActividades: ['']
    })
    this.getListaActividades();
    this.getListaActividadesPorFicha();


  }

  filtradoActividades(evento) {
    console.log(evento);
    if (evento.value.length == 0) {
      this.getListaActividades();
      this.formularioActividades = this.formBuilder.group({
        descripcionActividades: [''],
        observacionActividades: ['']
      })
      this.actividadActualSelec = evento.itemValue;
      this.varObser = false;
      this.varDes = false;
    } else {
      if (evento.itemValue.des_referencia == 'OTRO') {
        this.formularioActividades = this.formBuilder.group({
          descripcionActividades: [''],
          observacionActividades: ['']
        })
        this.actividadActualSelec = evento.itemValue;
        this.varObser = true;
        this.varDes = true;
      } else {
        this.formularioActividades = this.formBuilder.group({

          descripcionActividades: [evento.itemValue.txt_referencia, false],
          observacionActividades: ['']
        })
        this.actividadActualSelec = evento.itemValue;
        this.varObser = true;
        this.varDes = false;
      }
    }
    this.listaActividadesFiltradas = this.listaActividades.filter(opcion => evento.value.find(seleccionado => seleccionado.des_referencia == opcion.des_referencia))
  }

  /**
  * listados Actividades Adicionales
  */
  getListaActividades() {
    this.coreService.get('/listas/actividadesAdicionales').subscribe(
      (res: any) => {

        this.listaActividades = res;
        this.listaActividadesFiltradas = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  /**
  * listados Actividades Adicionales
  */
  getListaActividadesPorFicha() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.columnasActividades = [
      { header: 'Actividad', field: 'des_referencia' },
      { header: 'Descripción', field: 'descripcion_otra' },
      { header: 'Observación', field: 'observaciones' }
    ];
    this.coreService.getWithParams('/actividades-adicionales-ficha', params).subscribe(
      (res: any) => {
        this.registrosListaActividades = res.actividades;
        this.totalRecordsActividades = res.actividades.length;

      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  confirmacionGuardarActividadAdicional() {
    this.confirmationService.confirm({
      message: '¿Desea asignar esta actividad a la ficha?',
      accept: () => {
        this.guardarActividadAdicional();
      }
    });
  }
  guardarActividadAdicional() {
    let params = {
      ficha_id: this.fichaActual,
      actividad_id: this.actividadActualSelec.id,
      descripcion_otra: this.formularioActividades.value.descripcionActividades,
      observaciones: this.formularioActividades.value.observacionActividades
    }
    var actividad_id = this.actividadActualSelec.id;
    if (this.actividadActualSelec.des_referencia == 'OTRO') {

      this.coreService.post('/guardar-actividad-adicional', params).subscribe(
        (res: any) => {
          this.msj.info('Registro Guardado Correctamente');
          this.getListaActividadesPorFicha();
          this.verFormulario = false;
          this.formulario.reset();
        },
        (err: any) => {
        }
      )
    } else {
      var busqueda = this.registrosListaActividades.filter(function (registro) {
        console.log(registro);
        return registro.actividad_id == actividad_id;
      });
      var firstObj = (busqueda.length > 0) ? busqueda[0] : null;
      if (firstObj == null) {
        this.coreService.post('/guardar-actividad-adicional', params).subscribe(
          (res: any) => {
            this.msj.info('Registro Guardado Correctamente');
            this.getListaActividadesPorFicha();
          },
          (err: any) => {
          }
        )
      } else {
        this.msj.error('La actividad ya ha sido asignada a esta ficha');
      }
    }

  }

  confirmacionEliminarActividadAdicional(id) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar esta actividad?',
      accept: () => {
        this.eliminarActividadAdicional(id);
      }
    });
  }
  eliminarActividadAdicional(id) {
    let params = {
      id: id,
    }
    this.coreService.post('/eliminar-actividad-adicional', params).subscribe(
      (res: any[]) => {
        this.msj.info('Se eliminó la actividad correctamente');
        this.getListaActividadesPorFicha();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }


}
